import React from 'react';
import { useCms } from '../cms/CmsContext';
import { getCmsImagePath } from '../cms/cmsData';
import AnnouncementBar from '../components/AnnouncementBar';
import Footer from '../components/Footer';
import SponsorsSection from '../components/SponsorsSection';
import ScrollToTop from '../components/ScrollToTop';
import TornPaperWrapper from '../components/TornPaperWrapper';
import { getArabicTranslation } from '../utils/arabicTranslations';
import './About.css';

const ABOUT_PARAGRAPH_1 = 'The OC MENA Festival is a large-scale celebration honoring the rich traditions, creativity, diversity, and culture of the Arabic-speaking countries of the MENA (Middle East and North Africa). Held in the heart of Orange County, the festival brings communities together through music, art, food, fashion, and immersive experiences that reflect both heritage and modern culture. From vibrant bazaars and live performances to family-friendly attractions and entertainment, OC MENA Festival is designed to be an inclusive space for all ages and backgrounds.';

const About = () => {
  const { content } = useCms();
  const cms = content?.aboutPage || {};
  
  return (
    <div className="page-wrapper">
      <AnnouncementBar />
      
      <section className="hero-section">
        <div className="hero-background-wrapper">
          <video 
            src={"/hero-final.mp4"} 
            alt="oc mena festival" 
            className="hero-background-video"
            autoPlay
            muted
            loop
            playsInline
          />
          <div className="hero-gradient-overlay"></div>
        </div>

        <TornPaperWrapper>
          <h1 className="card-title">
            {cms.title}
            <span className="arabic-text on-white">{getArabicTranslation(cms.title || 'About')}</span>
          </h1>
          <div className="card-content">
            <p className="card-description">
              {ABOUT_PARAGRAPH_1}
            </p>
            <p className="card-description">
              {cms.paragraph2}
            </p>
          </div>
        </TornPaperWrapper>

        <div className="lanterns-container">
          <img loading="lazy" src={getCmsImagePath('lanterns', '/lanterns.webp')} alt="festival lanterns" className="lanterns-image" />
        </div>
      </section>

      <SponsorsSection />
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default About;
